import { FormLayout, TextInput } from 'components/common'
import {
  CommonFormType,
  aggregatorFormFields as AFF,
  getNestErrorMessage,
} from '../utils'
import JSONInputText from './jsonInputText'
import { Control } from 'react-hook-form'
import SwitchField from 'components/bundleProduct/switchField'

type AggregatorDetailsFormType = {
  isEditPage?: boolean
  control: Control<any>
  disabled?: boolean
} & Pick<CommonFormType, 'register' | 'errors'>

const AggregatorSapConfigForm = ({
  register,
  control,
  errors,
  isEditPage = false,
  disabled = false,
}: AggregatorDetailsFormType) => {
  return (
    <>
      <h3 className="title mb-1 ">SAP Config</h3>

      <FormLayout>
        <div className="grid gap-2 md:grid-cols-2 md:gap-5 lg:grid-cols-3">
          <TextInput
            required={!isEditPage}
            register={register}
            name={AFF.SAP_DOC_TYPE.parentKey + '.' + AFF.SAP_DOC_TYPE.key}
            label={AFF.SAP_DOC_TYPE.label}
            error={getNestErrorMessage(errors, AFF.SAP_DOC_TYPE)}
            disabled={disabled}
          />
          <TextInput
            required={!isEditPage}
            register={register}
            name={
              AFF.SAP_RMA_DOC_TYPE.parentKey + '.' + AFF.SAP_RMA_DOC_TYPE.key
            }
            label={AFF.SAP_RMA_DOC_TYPE.label}
            error={getNestErrorMessage(errors, AFF.SAP_RMA_DOC_TYPE)}
            disabled={disabled}
          />

          <TextInput
            required={!isEditPage}
            register={register}
            name={AFF.SAP_SALES_ORG.parentKey + '.' + AFF.SAP_SALES_ORG.key}
            label={AFF.SAP_SALES_ORG.label}
            error={getNestErrorMessage(errors, AFF.SAP_SALES_ORG)}
            disabled={disabled}
          />

          <TextInput
            required={!isEditPage}
            register={register}
            name={
              AFF.SAP_DISTR_CHANNEL.parentKey + '.' + AFF.SAP_DISTR_CHANNEL.key
            }
            label={AFF.SAP_DISTR_CHANNEL.label}
            error={getNestErrorMessage(errors, AFF.SAP_DISTR_CHANNEL)}
            disabled={disabled}
          />

          <TextInput
            required={!isEditPage}
            register={register}
            name={AFF.SAP_DIVISION.parentKey + '.' + AFF.SAP_DIVISION.key}
            label={AFF.SAP_DIVISION.label}
            error={getNestErrorMessage(errors, AFF.SAP_DIVISION)}
            disabled={disabled}
          />

          <TextInput
            required={!isEditPage}
            register={register}
            name={
              AFF.SAP_CUSTOMER_CODE.parentKey + '.' + AFF.SAP_CUSTOMER_CODE.key
            }
            label={AFF.SAP_CUSTOMER_CODE.label}
            error={getNestErrorMessage(errors, AFF.SAP_CUSTOMER_CODE)}
            disabled={disabled}
          />

          <JSONInputText
            control={control}
            placeholder="Enter Partners list in JSON format..."
            name={
              AFF.SAP_PARTNERS_LIST.parentKey + '.' + AFF.SAP_PARTNERS_LIST.key
            }
            label={AFF.SAP_PARTNERS_LIST.label}
            error={getNestErrorMessage(errors, AFF.SAP_PARTNERS_LIST)}
            required={!isEditPage}
            disabled={disabled}
          />
        </div>

        <div className="mt-3 rounded-lg border border-gray-200 bg-white p-5 shadow-sm">
          <SwitchField
            control={control}
            name={
              AFF.SAP_SHOULD_SEND_CREDIT_SALE.parentKey +
              '.' +
              AFF.SAP_SHOULD_SEND_CREDIT_SALE.key
            }
            label="SAP Credit Sale Sync"
            description="When enabled, all eligible orders synced to SAP will include the credit sale reference identifier."
            disabled={disabled}
          />
        </div>
      </FormLayout>
    </>
  )
}

export default AggregatorSapConfigForm
